// Check any survey validations
import { syncSurveySubmitState } from './UpdateProgressBar';

const ISSUE_BADGE_HTML = "<div class='Badge red' style='font-size: 12px; margin-right: 24px;'>Issues</div>";
const COMPLETE_BADGE_HTML = "<div class='Badge green' style='font-size: 12px; margin-right: 24px;'>Complete</div>";
const INCOMPLETE_BADGE_HTML = "<div class='Badge amber' style='font-size: 12px; margin-right: 24px;'>Incomplete</div>";

const STATUS_OPTIONS = {
  issues: { html: ISSUE_BADGE_HTML },
  complete: { html: COMPLETE_BADGE_HTML },
  incomplete: { html: INCOMPLETE_BADGE_HTML }
};

function toAnswerString(value) {
  if (value === null || typeof value === 'undefined') { return ''; }
  if (typeof value === 'string') { return value; }
  if (typeof value === 'number') { return value.toString(); }
  if (typeof value === 'object') {
    if (typeof value.value !== 'undefined') { return `${value.value}`; }
    if (typeof value.label !== 'undefined') { return `${value.label}`; }
  }
  return value.toString();
}

function renderQuestionGroupStatus(statusEl, statusKey) {
  const status = STATUS_OPTIONS[statusKey];
  if (!status) { return; }

  statusEl.empty().append(status.html);
}

function extractInputValue(inputEl) {
  const el = $(inputEl);

  const directVal = (el.val() || '').toString().trim();
  if (directVal.length > 0) { return directVal; }

  const typeaheadInput = el.closest('.twitter-typeahead').find('.tt-input').first();
  if (typeaheadInput && typeaheadInput.length > 0) {
    const ttVal = (typeaheadInput.val() || '').toString().trim();
    if (ttVal.length > 0) { return ttVal; }
  }

  return '';
}

function resolveAnswerFieldValue(rowEl) {
  const inputs = rowEl.find('.answer-text');
  if (!inputs || inputs.length === 0) { return ''; }

  let resolved = '';

  inputs.each((_, inputEl) => {
    const candidate = extractInputValue(inputEl);
    if (candidate.length > 0) {
      resolved = candidate;
      return false;
    }
    return true;
  });

  if (resolved.length > 0) { return resolved; }

  return resolved;
}

function isQuestionRowComplete(row, overrideValue) {
  if (row.hasClass('d-none')) { return true; }

  const answerInput = row.find('.answer-text');
  if (answerInput.length === 0) { return true; }
  if (answerInput.is(':disabled')) { return true; }

  const rawValue = (typeof overrideValue !== 'undefined') ? overrideValue : resolveAnswerFieldValue(row);
  const value = toAnswerString(rawValue).trim();
  if (value.length > 0) { return true; }

  const markNa = row.find('.mark-not-applicable').is(':checked');
  const preferNotDisclose = row.find('.prefer-not-disclose').is(':checked');
  return markNa || preferNotDisclose;
}

function isTableRowComplete(row, overrideValue) {
  if (row.hasClass('d-none')) { return true; }

  const enabledInputs = row.find('.survey-table-cell .answer-text:not(:disabled)');
  if (enabledInputs.length === 0) { return true; }

  if (typeof overrideValue !== 'undefined' && toAnswerString(overrideValue).trim().length > 0) {
    return true;
  }

  let hasValue = false;
  enabledInputs.each((_, inputEl) => {
    const val = extractInputValue(inputEl);
    if (val.length > 0) {
      hasValue = true;
      return false;
    }
    return true;
  });

  return hasValue;
}

function areRequiredRowsComplete(questionGroupCard, overrideContext) {
  const questionRows = questionGroupCard.find('.question-row[data-question-id][data-required="true"]');
  const tableRows = questionGroupCard.find('.question-row[data-table-id]');
  if (questionRows.length === 0 && tableRows.length === 0) { return true; }

  let allComplete = true;
  questionRows.each((_, rowEl) => {
    const $row = $(rowEl);
    const shouldOverride = overrideContext && overrideContext.row && overrideContext.row.is($row);
    const overrideValue = shouldOverride ? overrideContext.value : undefined;
    if (!isQuestionRowComplete($row, overrideValue)) {
      allComplete = false;
      return false;
    }
    return true;
  });

  if (!allComplete) { return false; }

  tableRows.each((_, rowEl) => {
    const $row = $(rowEl);
    const shouldOverride = overrideContext && overrideContext.row && overrideContext.row.is($row);
    const overrideValue = shouldOverride ? overrideContext.value : undefined;
    if (!isTableRowComplete($row, overrideValue)) {
      allComplete = false;
      return false;
    }
    return true;
  });

  return allComplete;
}

function updateQuestionGroupStatus(questionRowEl, overrideValue) {
  if (!questionRowEl || questionRowEl.length === 0) { return; }

  const questionGroupCard = questionRowEl.closest('.card[data-question-group-id]');
  if (!questionGroupCard || questionGroupCard.length === 0) { return; }

  const questionGroupId = questionGroupCard.data('question-group-id');
  const statusEl = questionGroupCard.find(`.question-group-status[data-question-group-id='${questionGroupId}']`);
  if (!statusEl || statusEl.length === 0) { return; }

  const hasErrors = questionGroupCard.find('.question-row.border-error').length > 0;
  if (hasErrors) {
    renderQuestionGroupStatus(statusEl, 'issues');
    return;
  }

  const overrideContext = (typeof overrideValue === 'undefined') ? null : { row: questionRowEl, value: overrideValue };
  if (areRequiredRowsComplete(questionGroupCard, overrideContext)) {
    renderQuestionGroupStatus(statusEl, 'complete');
    return;
  }

  renderQuestionGroupStatus(statusEl, 'incomplete');

}

export function refreshVisibleQuestionGroupStatuses() {
  $('.card[data-question-group-id]').each((_, cardEl) => {
    const questionGroupCard = $(cardEl);
    if (questionGroupCard.hasClass('d-none')) { return; }

    const questionRows = questionGroupCard.find('.question-row[data-question-id]');
    const tableRows = questionGroupCard.find('.question-row[data-table-id]');

    // Collapsed groups do not render their body rows; keep their existing badge
    // rather than misclassifying them from incomplete local DOM.
    if (questionRows.length === 0 && tableRows.length === 0) { return; }

    const questionGroupId = questionGroupCard.data('question-group-id');
    const statusEl = questionGroupCard.find(`.question-group-status[data-question-group-id='${questionGroupId}']`);
    if (!statusEl || statusEl.length === 0) { return; }

    const hasErrors = questionGroupCard.find('.question-row.border-error').length > 0;
    let resolvedStatusKey;
    if (hasErrors) {
      resolvedStatusKey = 'issues';
    } else if (areRequiredRowsComplete(questionGroupCard, null)) {
      resolvedStatusKey = 'complete';
    } else {
      resolvedStatusKey = 'incomplete';
    }
    renderQuestionGroupStatus(statusEl, resolvedStatusKey);
  });

  syncSurveySubmitState();
}

if (typeof window !== 'undefined') {
  window.refreshVisibleQuestionGroupStatuses = refreshVisibleQuestionGroupStatuses;
}

export default function(el, answer_text) {
  const normalizedAnswer = toAnswerString(answer_text);
  const question_row_el = el.closest('.question-row');
    const validations = question_row_el.data('validations');

  // Remove existing error state and return if no validations
  if (!validations || validations.length === 0) {
    const errorContainer = question_row_el.find('.error-container');
    question_row_el.removeClass('border-error');
    errorContainer.addClass('d-none');
    errorContainer.find('.Badge').attr('data-original-title', '');
    $('[data-toggle="tooltip"]').tooltip('dispose').tooltip();
    updateQuestionGroupStatus(question_row_el, normalizedAnswer);
    syncSurveySubmitState();
    return;
  }

  // Otherwise, check validations and set errors if applicable
  let errors = [];

  validations.forEach(validation => {
    const { operator, validation_value, validation_value_type, validating_question_id } = validation;
    let vv = validation_value;

    // If validating_question_id is present, get its answer value from DOM
    if (validating_question_id) {
      const validatingRow = document.querySelector(`.question-row[data-question-id='${validating_question_id}']`);
      if (validatingRow) {
        const input = validatingRow.querySelector('.answer-text');
        vv = input ? input.value : vv;
      }
    }

    // Skip if no validation value
    if (!vv) return;

    // Numeric versions
    const answerNum = parseFloat(normalizedAnswer);
    const vvNum = parseFloat(vv);

    // String validations
    if (operator === 'Equals') {
      if ((normalizedAnswer !== vv) && (answerNum !== vvNum)) {
        errors.push(`Response must equal ${vv}`);
      }
    } else if (operator === 'Does not equal') {
      if ((normalizedAnswer === vv) || (answerNum === vvNum)) {
        errors.push(`Response must not equal ${vv}`);
      }
    } else if (operator === 'Greater than') {
      if (answerNum <= vvNum) {
        errors.push(`Response must be greater than ${vv}`);
      }
    } else if (operator === 'Greater than or equal to') {
      if (answerNum < vvNum) {
        errors.push(`Response must be greater than or equal to ${vv}`);
      }
    } else if (operator === 'Less than') {
      if (answerNum >= vvNum) {
        errors.push(`Response must be less than ${vv}`);
      }
    } else if (operator === 'Less than or equal to') {
      if (answerNum > vvNum) {
        errors.push(`Response must be less than or equal to ${vv}`);
      }
    } else if (operator === 'Min Length') {
      if (parseInt(vv, 10) === 1 && (normalizedAnswer.length < 1)) {
        errors.push(`Response is required`);
      } else if (normalizedAnswer.length < parseInt(vv, 10)) {
        errors.push(`Response length must be at least ${vv}`);
      }
    } else if (operator === 'Max Length') {
      if (normalizedAnswer.length > parseInt(vv, 10)) {
        errors.push(`Response length cannot be greater than ${vv}`);
      }
    }

  });

  // Display errors in the UI
  let errorContainer = question_row_el.find('.error-container');
  if (errors.length > 0) {
    question_row_el.addClass('border-error');
    errorContainer.removeClass('d-none');
    errorContainer.find('.Badge').attr('data-original-title', errors.join('<br>'));
    $('[data-toggle="tooltip"]').tooltip('dispose').tooltip();
  } else {
    question_row_el.removeClass('border-error');
    errorContainer.addClass('d-none');
    errorContainer.find('.Badge').attr('data-original-title', '');
    $('[data-toggle="tooltip"]').tooltip('dispose').tooltip();
  }

  updateQuestionGroupStatus(question_row_el, normalizedAnswer);
  syncSurveySubmitState();

  return errors;

}
